<template>
  <router-view/>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue';
import { useRouter } from 'vue-router';

export default defineComponent({
  components: {},
  setup(){
    const router = useRouter()
    const path = ref()

    watch(router.currentRoute,()=>{
      path.value = window.location.pathname;
      if (router.currentRoute.value.name=='dashboard') {
        if (!localStorage.getItem('phone')) {
          router.push({'name':'sign-in'})
        }
      }
    })

    return{
      router,
      path
    }
  }

})
</script>

<style>
@import url('./assets/scss/style.scss');
#app {
  font-family: iransans;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
